import { render, staticRenderFns } from "./TypeImagePanel.vue?vue&type=template&id=748119f0&scoped=true"
import script from "./TypeImagePanel.vue?vue&type=script&lang=js"
export * from "./TypeImagePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748119f0",
  null
  
)

export default component.exports